import { useAutocomplete } from 'admin';
import type { MaterialColour } from 'api';
import { capitalizeString } from 'ui';

import { AutocompleteField, type AutocompleteFieldProps } from '../AutocompleteField/AutocompleteField';

export const MaterialColourAutocomplete = (props: Omit<AutocompleteFieldProps<MaterialColour>, 'options'>) => {
  const { autocompleteProps } = useAutocomplete<MaterialColour>({
    resource: '/materials/v1/material-colours/',
  });

  return (
    <AutocompleteField<MaterialColour>
      data-testid="material-colour-autocomplete"
      getOptionLabel={(item) => (item?.name ? capitalizeString(item?.name) : '')}
      valueField="id"
      {...autocompleteProps}
      filterOptions={(options, state) =>
        options.filter((option) => option.name.toLowerCase().includes(state.inputValue.toLowerCase()))
      }
      {...props}
    />
  );
};
